import { Box, Button, List } from "@mui/material";
import { CategoryConfig } from "../../config/categories-config";
import CategoryListItem from "./category-list-item";

interface CategorySidebarProps {
  categories: (CategoryConfig & { count: number })[];
  selectedCategory: number;
  dragOverCategory: number | null;
  isLoading: boolean;
  onCategorySelect: (categoryId: number) => void;
  onDragOver: (e: React.DragEvent<HTMLDivElement>, categoryId: number) => void;
  onDragLeave: () => void;
  onDrop: (e: React.DragEvent<HTMLDivElement>, categoryId: number) => void;
  getCategoryBackground: (categoryId: number) => string | undefined;
  onCleanse: () => void;
}

export const CategorySidebar: React.FC<CategorySidebarProps> = ({
  categories,
  selectedCategory,
  dragOverCategory,
  isLoading,
  onCategorySelect,
  onDragOver,
  onDragLeave,
  onDrop,
  getCategoryBackground,
  onCleanse,
}) => {
  return (
    <Box
      sx={{
        width: 262,
        display: "flex",
        flexDirection: "column",
        borderRight: "1px solid #eee",
        height: "auto",
      }}
    >
      <List dense sx={{ flex: 1 }}>
        {categories.map((cat) => (
          <CategoryListItem
            key={cat.label}
            category={cat}
            isSelected={selectedCategory === cat.categoryId}
            isDragOver={dragOverCategory === cat.categoryId}
            background={getCategoryBackground(cat.categoryId)}
            isLoading={isLoading}
            onSelect={() => onCategorySelect(cat.categoryId)}
            onDragOver={(e) => onDragOver(e, cat.categoryId)}
            onDragLeave={onDragLeave}
            onDrop={(e) => onDrop(e, cat.categoryId)}
          />
        ))}
      </List>
      <Box
        sx={{
          borderTop: "1px solid #eee",
          py: 2,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ borderRadius: 1, minWidth: 100 }}
          onClick={onCleanse}
        >
          Cleanse
        </Button>
      </Box>
    </Box>
  );
};

const CategorySidebarComponent = CategorySidebar;
export default CategorySidebarComponent;
